module.exports = {
    siteTitle: 'PaaSat', // <title>
    manifestName: 'PaaSat',
    manifestShortName: 'PaaSat', // max 12 characters
    manifestStartUrl: '/',
    manifestBackgroundColor: '#131114',
    manifestThemeColor: '#272429',
    manifestDisplay: 'standalone',
    manifestIcon: 'src/assets/img/website-icon.png',
    pathPrefix: `/gatsby-starter-overflow/`, // This path is subpath of your hosting https://domain/portfolio
    authorName: 'PaaSat',
    heading: 'Connecting The World with Satellites..',
    // social
    socialLinks: [{
            icon: 'fa-github',
            name: 'Github',
            url: 'https://github.com/',
        },
        {
            icon: 'fa-twitter',
            name: 'Twitter',
            url: 'https://twitter.com/',
        },
        {
            icon: 'fa-facebook',
            name: 'Facebook',
            url: 'https://facebook.com/',
        },
        {
            icon: 'fa-envelope-o',
            name: 'Email',
            url: 'mailto:paajoeincorporations@gmail.com',
        },
    ],
};